import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserLink from './UserLink';
import UserLinkPopover from './UserLinkPopover';
export var UserLinkWithTooltip = function (_a) {
    var user = _a.user, className = _a.className, contentClassName = _a.contentClassName, biData = _a.biData, relatedItemBiData = _a.relatedItemBiData, withTooltip = _a.withTooltip, props = __rest(_a, ["user", "className", "contentClassName", "biData", "relatedItemBiData", "withTooltip"]);
    var isMobile = useContext(MobileContext);
    // in some cases this could be null, example deviation.author
    if (!user) {
        return null;
    }
    var isGroup = user.type && user.type.includes('group');
    var shouldRenderTooltip = withTooltip && !isMobile && !isGroup;
    if (!shouldRenderTooltip) {
        return (React.createElement(UserLink, __assign({ user: user, className: classnames(className, contentClassName), biData: biData }, props)));
    }
    return (React.createElement(UserLinkPopover, { user: user, className: className, relatedItemBiData: relatedItemBiData, biData: biData },
        React.createElement(UserLink, __assign({ user: user, className: contentClassName }, props))));
};
UserLinkWithTooltip.displayName = 'UserLinkWithTooltip';
export default UserLinkWithTooltip;
//# sourceMappingURL=UserLinkWithTooltip.js.map